/**
 * @generated SignedSource<<e2164857e406f4a3a588285b9e2cc5f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type favoritePageHero_fragment$data = {
  readonly __typename: "CasePotentialBuyer";
  readonly baseCase: {
    readonly gpsCoordinates: string | null | undefined;
    readonly mediaDataConnection: {
      readonly " $fragmentSpreads": FragmentRefs<"caseImages_Media">;
    } | null | undefined;
    readonly noAdvertisement: boolean | null | undefined;
    readonly openHouse: ReadonlyArray<{
      readonly __typename: "OpenHouse";
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"matchHeroContentFragment_baseCase" | "openHouseImageOverlay_baseCase" | "registerOpenHouseModalFragment">;
  } | null | undefined;
  readonly offmarketCase: {
    readonly mediaDataConnection: {
      readonly " $fragmentSpreads": FragmentRefs<"caseImages_Media">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"matchHeroContentFragment_offmarketCase">;
  } | null | undefined;
  readonly " $fragmentType": "favoritePageHero_fragment";
};
export type favoritePageHero_fragment$key = {
  readonly " $data"?: favoritePageHero_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"favoritePageHero_fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaDataConnection",
  "kind": "LinkedField",
  "name": "mediaDataConnection",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "caseImages_Media"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "favoritePageHero_fragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "baseCase",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "matchHeroContentFragment_baseCase"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "registerOpenHouseModalFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "openHouseImageOverlay_baseCase"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noAdvertisement",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gpsCoordinates",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "amount",
              "value": 2
            }
          ],
          "concreteType": "OpenHouse",
          "kind": "LinkedField",
          "name": "openHouse",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": "openHouse(amount:2)"
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OffmarketCase",
      "kind": "LinkedField",
      "name": "offmarketCase",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "matchHeroContentFragment_offmarketCase"
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "CasePotentialBuyer",
  "abstractKey": null
};
})();

(node as any).hash = "3badb7e9841c7a42bc79d91b3da25154";

export default node;
